import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import PageBase from "../../components/PageBase";
import * as ROUTES from '../../utils/routes';
import FundsReceived from "./Widgets/FundsReceived";
import MarketingEvents from "./Widgets/MarketingEvents";
import MarketingAssets from "./Widgets/MarketingAssets";
import FundsList from "./Widgets/FundsList";
import * as programActions from "../../redux/Program/actions.js";
import ProgramCategoryBox from "./Widgets/ProgramCategoryBox";

import './Widgets/Widgets.scss';
import {appendProgramsCategories} from "./programUtils.js";

const Partnership = props => {
	const navigate = useNavigate();
	const programs = useSelector(state => state.program).programs;
	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			await dispatch(programActions.loadPrograms([]));
		};
		load();
	}, []);

	const showReport = (title, data, selectedObject) => {
		navigate(ROUTES.DASHBOARD_REPORT, { state: { title, data, selectedObject } });
	};

	let programsWithCategories = [];

	if(programs) {
		programsWithCategories = appendProgramsCategories(programs);
	}
// console.log(programsWithCategories);
	return (
		<PageBase title="Partnership">
			{
				programs &&
				<div className="widgets-container" style={{gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', minHeight: '250px', marginBottom: '0'}}>
					<ProgramCategoryBox programs={programsWithCategories.filter(p => p.category === 'Tier')}>Tier</ProgramCategoryBox>
					<ProgramCategoryBox programs={programsWithCategories.filter(p => p.category === 'Compensation')}>Compensation</ProgramCategoryBox>
					<ProgramCategoryBox programs={programsWithCategories.filter(p => p.category === 'Differentiation')}>Differentiation</ProgramCategoryBox>
					<ProgramCategoryBox programs={programsWithCategories.filter(p => p.category === 'Promotion')}>Promotion</ProgramCategoryBox>
					<ProgramCategoryBox programs={programsWithCategories.filter(p => p.category === 'Integration')}>Integration</ProgramCategoryBox>
				</div>
			}

			<div className="widgets-container" style={{gridTemplateColumns: '1fr 1fr'}}>
				<MarketingEvents showReport={widget => showReport('Marketing Events', widget.data.data, 'marketing')} />
				<MarketingAssets showReport={widget => showReport('Marketing Assets', widget.data.data, 'marketing')} />
				<FundsList showReport={widget => showReport('Funds Pipeline', widget.data.data, 'funds')} />
				<FundsReceived showReport={widget => showReport('Funds Received', widget.data.data, 'funds')} />
			</div>
		</PageBase>
	);
};

export default Partnership;
